import { ADD_FOURNISSEUR_SUPPORT, LISTE_FOURNISSEUR_SUPPORT, DETAIL_FOURNISSEUR_SUPPORT } from './fournisseurSupport/fournisseurSupport';
import { LIST_LIEU_LIVRAISON } from './lieuDeLivraison/lieuDeLivraison';
import { RAPPROCHEMENT_ACHAT } from './rapprochement/rapprochement';
import { LISTE_FOURNISSEURS, ADD_EDIT_FOURNISSEURS, DETAIL_FOURNISSEURS } from './fournisseurs/fournisseurs';
import LISTE_LIGNE_COMMANDE_ACHAT from './ligneCommandeAchat/listeLigneCommandeAchat';
import * as commande from './commandesAchatFournisseur/commandes';
import * as bonReception from './bonReception/bonReception';
import * as facture from './facturesAchatFournisseur/factures';
import LISTE_SUIVI_ACHATS from './suiviAchats/suiviAchats';

const ACHAT = {
  listeFournisseurSupport: LISTE_FOURNISSEUR_SUPPORT,
  addEditFournisseurSupport: ADD_FOURNISSEUR_SUPPORT,
  detailFournisseurSupport: DETAIL_FOURNISSEUR_SUPPORT,
  listLieuDeLivraison: LIST_LIEU_LIVRAISON,
  rapprochementAchat: RAPPROCHEMENT_ACHAT,
  listFournisseurs: LISTE_FOURNISSEURS,
  addEditFournisseurs: ADD_EDIT_FOURNISSEURS,
  detailFournisseurs: DETAIL_FOURNISSEURS,
  listeLigneCommandeAchat: LISTE_LIGNE_COMMANDE_ACHAT,
  listeCommandesAchat: commande.LISTE_COMMANDES,
  addEditCommande: commande.ADD_EDIT_COMMANDE,
  detailCommandeAchatFournisseur: commande.DETAIL_COMMANDE,
  listeBonReception: bonReception.LISTE_BON_RECEPTION,
  addEditBonReception: bonReception.ADD_EDIT_BON_RECEPTION,
  detailBonReception: bonReception.DETAIL_BON_RECEPTION,
  listeFactureAchatFournisseur: facture.LISTE,
  addEditFactureAchat: facture.ADD_EDIT,
  detailFactureAchat: facture.DETAIL,
  listeSuiviAchats: LISTE_SUIVI_ACHATS,
};

export default ACHAT;
